import { render, staticRenderFns } from "./TaskUpdateDescription.vue?vue&type=template&id=7a3ab0f2&scoped=true"
import script from "./TaskUpdateDescription.vue?vue&type=script&lang=js"
export * from "./TaskUpdateDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3ab0f2",
  null
  
)

export default component.exports